var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.isMobile)?_c('NavigationMobile'):_c('Navigation')}
var staticRenderFns = []

export { render, staticRenderFns }